import React from 'react';
import '../template-file-css/document-file-template.css';


export const JHC_AdultHippaAuthForm = ({ itemsRef, showErrorFor }) => {

    return (
        <form id='JHC_AdultHippaAuthForm' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'>
                    <b> <center> HIPAA AUTHORIZATION FORM & DISCLOSURE of Protected Health Information  </center> </b>
                </p>

                <p className='w-750'>
                    Communication between your behavioral health provider(s) and your primary care physician (PCP) is important to make sure all care is complete, comprehensive, and well coordinated. This form allows your behavioral health provider to share valuable information with your PCP. No information will be released without your signed authorization. Once completed and signed, please give this form to your behavioral health provider.
                </p>
                <p className='w-750'>
                    <b> Section 1: Patient Information </b>
                </p>
                <table>
                    <tr>
                        <td className='w-250'> <span className='eleHeader'>First Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Last Name:</span> </td>
                        <td className='w-250'> <span className='eleHeader'>DOB:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-250'>  <input id='txtFirstName' name='txtFirstName' type='text' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtLastName' name='txtLastName' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtDob' name='txtDob' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-750'> <span className='eleHeader'>Address:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-750'>  <input id='txtAddress' name='txtAddress' type='text' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Phone Number:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>Social Security Number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input id='txtPhoneNumber' name='txtPhoneNumber' type='text' className='add-only' /> </td>
                        <td className='w-375'> <input type='text' id='txtSocialSecurityNumber' name='txtSocialSecurityNumber' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    I hereby authorize the disclosure of protected health information about the individual named above.
                    I am: the individual named above (complete Section 6 below to sign this form) a personal representative because the patient is a minor, incapacitated, or deceased (complete Section 7 below)
                </p>
                <p className='w-750'>
                    <b> Section 2. The information may be disclosed to the following primary care physician: </b>
                </p>
                <table>
                    <tr>
                        <td className='w-500'> <span className='eleHeader'>Name (a person, or an organization if you are naming a practice):</span> </td>
                        <td className='w-250'> <span className='eleHeader'>Phone Number:</span> </td>
                    </tr>
                    <tr>
                        <td className='w-500'>  <input id='txtName' name='txtName' type='text' className='add-only' /> </td>
                        <td className='w-250'> <input type='text' id='txtPhoneNumber' name='txtPhoneNumber' className='add-only' /> </td>
                    </tr>
                    <tr>
                        <td className='w-375'> <span className='eleHeader'>Street Address:</span> </td>
                        <td className='w-375'> <span className='eleHeader'>City, State and Zip Code::</span> </td>
                    </tr>
                    <tr>
                        <td className='w-375'>  <input id='txtStreetAddress' name='txtStreetAddress' type='text' className='add-only' /> </td>
                        <td className='w-375'>  <input id='txtCityState' name='txtCityState' type='text' className='add-only' /> </td>
                    </tr>
                </table>
                <p className='w-750'>
                    I hereby authorize use or disclosure of protected health information about me as described below.
                    <ol>
                        <li>The following specific person/class of person/facility is authorized to use or disclose information about me:
                            <br />
                            <b>
                                Jackson Hands of Change 4035 Washington Avenue New Orleans, LA 70125 Phone 504-535-5082 Fax 877-250-2283</b>
                        </li>
                        <li>The following person (or class of persons) may receive disclosure of protected health information about me:
                            <br />
                            <b>
                                All external and internal sources used and contracted by Jackson Hands of Change purpose of my treatment, payment, and agency health care operations.</b>  The specific information that should be disclosed is (please give dates of service if possible):
                        </li>

                        <b>UNLESS YOU SIGN HERE,</b> NO INFORMATION ABOUT ALCOHOL/SUBSTANCE ABUSE, HIV/AIDS, OR MENTAL HEALTH WILL BE DISCLOSED:
                        <br />
                        <input type='radio' id='rbDiscloseInformation_YES' name='rbDiscloseInformation' className='add-only' value='YES' /> YES, DISCLOSE THIS INFORMATION *
                        <br />
                        <input type='radio' id='rbDiscloseInformation_NO' name='rbDiscloseInformation' className='add-only' value='NO' /> NO, DO NOT DISCLOSE THIS INFORMATION *

                        <li>I understand that the information used or disclosed may be subject to re-disclosure by the person or class of persons or facility receiving it, and would then no longer be protected by federal privacy regulations.</li>
                        <li>I may revoke this authorization by notifying Jackson Hands of Change in writing of my desire to revoke it.  However, I understand that any action already taken in reliance on this authorization cannot be reversed, and my revocation will not affect those actions.</li>
                        <li>My purpose/use of the information is for my treatment.</li>
                        <li>
                            This authorization expires on ________________, 20______, OR upon occurrence of the following event that relates to me or to the purpose of the intended use or disclosure of information about me:  _____________________________________.
                        </li>
                    </ol>

                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Print  Client Name </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Agency Representative </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature of Client, Guardian or Personal Representative  </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <center><b><u><i>A copy of this completed, signed and dated form must be given to the Individual or other signatory</i></u></b></center>

                </p>
                <p className='w-750'>
                    <b> <center> Authorization for Release of Client Information  </center> </b>
                </p>
                <p className='w-750'>
                    I <input type='text' id='txtAuthorizationReleaseClientInformationProviderName_1' name='txtAuthorizationReleaseClientInformationProviderName_1' className='add-only w-200 custom-add-only' /> hereby authorize <input type='text' id='txtAuthorizationReleaseClientInformationProviderName_2' name='txtAuthorizationReleaseClientInformationProviderName_2' className='add-only w-200 custom-add-only' /> to
                    Release to Jackson Hands of Change, 4035 Washington Avenue, New Orleans, LA 70125,  Phone 504-535-5082,  Fax:   877-250-2283, the information specified on this form with the knowledge that such release discloses the fact that behavioral health services have been / are being provided.
                </p>
                <table>
                    <tr>
                        <td className='w-750'><span className='eleHeader'>The disclosure of information is required for the following purpose(s): (initial applicable areas)</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPurpose_1' name='cbPurpose_1' className='add-only' value='Evaluation' /> Evaluation  <br />
                            <input type='checkbox' id='cbPurpose_2' name='cbPurpose_2' className='add-only' value='TreatmentPlanning' /> Treatment Planning <br />
                            <input type='checkbox' id='cbPurpose_3' name='cbPurpose_3' className='add-only' value='Other' /> Other(Specify):
                            <input type='text' id='txtPurpose_3Other' name='txtPurpose_3Other' className='add-only w-200 custom-add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>And shall be limited to releasing the following types of information (initial all applicable areas):</span>
                            From Date Required:
                            <input type='date' id='txtFromDateRequired' name='txtFromDateRequired' className='add-only w-200 custom-add-only' />

                            To date Required:
                            <input type='date' id='txtToDateRequired' name='txtToDateRequired' className='add-only w-200 custom-add-only' />;
                            or any information/ records indicated, regardless of date.

                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPurpose_4' name='cbPurpose_4' className='add-only' value='Entire record' /> Entire record  <br />
                            <input type='checkbox' id='cbPurpose_5' name='cbPurpose_5' className='add-only' value='Diagnosis' /> Diagnosis <br />
                            <input type='checkbox' id='cbPurpose_6' name='cbPurpose_6' className='add-only' value='Psychiatric Evaluation' /> Psychiatric Evaluation <br />
                            <input type='checkbox' id='cbPurpose_7' name='cbPurpose_7' className='add-only' value='Progress notes' /> Progress notes <br />
                            <input type='checkbox' id='cbPurpose_8' name='cbPurpose_8' className='add-only' value='Discharge Summary' /> Discharge Summary <br />
                            <input type='checkbox' id='cbPurpose_9' name='cbPurpose_9' className='add-only' value='Social History' /> Social History <br />
                            <input type='checkbox' id='cbPurpose_10' name='cbPurpose_10' className='add-only' value='Individual Treatment Plan' /> Individual Treatment Plan <br />
                            <input type='checkbox' id='cbPurpose_11' name='cbPurpose_11' className='add-only' value='Legal Information' /> Legal Information <br />
                            <input type='checkbox' id='cbPurpose_12' name='cbPurpose_12' className='add-only' value='Medical' /> Medical, neurological assessment, lab tests,e.g. EEG, EKG,etc. <br />
                            <input type='checkbox' id='cbPurpose_13' name='cbPurpose_13' className='add-only' value='OtherEvaluations' />Other Evaluations/Assessments (specify)
                            <input type='text' id='txtOtherEvaluations' name='txtOtherEvaluations' className='add-only w-200 custom-add-only' /> <br />
                            <input type='checkbox' id='cbPurpose_14' name='cbPurpose_14' className='add-only' value='Other' />Other: (Specify) Collaboration of services
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    This disclosure becomes effective <input type='date' id='txtAuthorizationReleaseClientInformationEffDate_1' name='txtAuthorizationReleaseClientInformationEffDate_1' className='add-only w-200 custom-add-only' />
                    and ends <input type='date' id='txtAuthorizationReleaseClientInformationEndDate_1' name='txtAuthorizationReleaseClientInformationEndDate_1' className='add-only w-200 custom-add-only' />.
                    The authorization can be revoked in writing by the undersigned at any time except to the extent action has already been taken.

                </p>
                <p className='w-750'>
                    I understand I am to receive a copy of this authorization

                </p>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Print  Client Name </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Agency Representative </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> Signature of Client, Guardian or Personal Representative  </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}